export const locale = {
    lang: 'en',
    data: {
        CONFIRM_DIALOG: {
            CONFIRM: 'Confirm',
            OK: 'OK',
            CANCEL: 'Cancel',
        },
    },
};
